/**
 * Yayındaki sürümü izler ve eskiyse sayfayı kendisi yeniler.
 *
 * Neden var: iOS'ta "Ana Ekrana Ekle" ile kurulan kısayol, `index.html`'i
 * önbellekte tutup eski paketi (main.<hash>.js) açmaya devam edebiliyor.
 * Eski paketler sunucudan silinmediği için (geri dönüş çalışsın diye) eski
 * arayüz hatasız çiziliyor ve kullanıcı güncellemeyi hiç görmüyor.
 * Uygulamayı arka plandan silmek işe yaramıyor; sorun HTTP önbelleğinde.
 *
 * Çözüm: çalışan paketin adını DOM'dan, yayındakini sunucudan taze çekip
 * karşılaştırmak. Fark varsa bir kez yeniden yükle.
 */

const PAKET = /main\.[a-z0-9]+\.js/;
const HEDEF_ANAHTAR = "surum-hedef";
const ARALIK = 10 * 60 * 1000;

/** Şu an çalışan paketin adı. Geliştirme sunucusunda hash'siz olduğu için null döner. */
function calisanPaket() {
  const etiket = document.querySelector('script[src*="/static/js/main."]');
  const eslesme = etiket && etiket.getAttribute("src").match(PAKET);
  return eslesme ? eslesme[0] : null;
}

/** Sunucudaki index.html'den yayındaki paketin adı. Önbellek tamamen atlanır. */
async function yayindakiPaket() {
  const yanit = await fetch(`/index.html?_=${Date.now()}`, {
    cache: "no-store",
    credentials: "same-origin",
  });
  if (!yanit.ok) return null;
  const eslesme = (await yanit.text()).match(PAKET);
  return eslesme ? eslesme[0] : null;
}

export function surumTakibiBaslat() {
  const calisan = calisanPaket();
  if (!calisan) return; // geliştirme kipi ya da beklenmedik yapı: karışma

  const kontrol = async () => {
    if (document.visibilityState === "hidden") return;
    let yayindaki;
    try {
      yayindaki = await yayindakiPaket();
    } catch {
      return; // ağ yoksa sessizce geç
    }
    if (!yayindaki || yayindaki === calisan) return;

    // Döngü emniyeti: bir sürüm için en fazla bir kez yenile. Yenileme yine
    // eski paketi getirdiyse (önbellek inat ediyorsa) tekrar denemeyiz.
    try {
      if (sessionStorage.getItem(HEDEF_ANAHTAR) === yayindaki) return;
      sessionStorage.setItem(HEDEF_ANAHTAR, yayindaki);
    } catch {
      return; // gizli sekmede depolama yoksa yenileme döngüsü riski alma
    }
    window.location.reload();
  };

  kontrol();
  document.addEventListener("visibilitychange", kontrol);
  setInterval(kontrol, ARALIK);
}
